import axios from 'axios'

//******************************************************/

// 本机服务器
// export const HTTP_MSG = 'http://localhost:8081'
// 测试服
// export const HTTP_MSG = 'https://shenghuikeji.cc/test'
// 正式服
export const HTTP_MSG = 'https://shenghuikeji.cc/api'

//******************************************************/

// export const WEBSOCKET_WX='http://localhost:8081/wstest' // 本机
// export const WEBSOCKET_WX='https://124.222.205.101/wstest' // 测试
// export const WEBSOCKET_WX='https://shenghuikeji.cc/ws' // 正式服

const token = 'q217ditnxkk5e7gscfmjcvkxx1p8nql2y6hln500cn2';

//******************************************************/

axios.defaults.withCredentials = true
// axios.defaults.baseURL =HTTP_MSG

// get 请求数据
export const GetMsg = (path, data) => {
    return new Promise(res => {
        axios.get(HTTP_MSG + path, {
            params: data,
            headers: {
                Authorization: token // 如果使用 Bearer Token
            }
        }).then(e => {
            res(e)
        })
    })
}

// post 请求数据
export const PostMsg = (path, data) => {
    return new Promise(res => {
        axios.post(HTTP_MSG + path, data, {
            headers: {
                'Authorization': token, // 如果使用 Bearer Token
                'Content-Type': 'multipart/form-data'
            }
        }).then(e => {
            res(e)
        })
    })
}

// 流式请求
export const PostMsgStream = async (path, data, func, timeout = 60000) => {


    const controller = new AbortController();
    const signal = controller.signal;

    // 设置超时，超时后中止请求
    const timeoutId = setTimeout(() => {
        console.warn("请求超时，终止请求");
        controller.abort();
    }, timeout);


    try {
        const response = await fetch(HTTP_MSG + path, {
            method: "POST",
            headers: {
                "Authorization": token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
            signal, // 绑定信号，支持中止
        });

        clearTimeout(timeoutId); // 请求成功，清除超时计时器


        if (!response.body) throw new Error("响应体为空");

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        let result = '';
        let isDone = false; // **标记流是否已完成**

        while (true) {
            const {done, value} = await reader.read();
            if (done) break;

            const textChunk = decoder.decode(value, {stream: true});

            // console.log("收到数据块:", textChunk);

            // **检查 textChunk 是否包含 [DONE]**
            if (textChunk.includes("[DONE]")) {
                console.log("检测到 [DONE]，结束流式读取");
                isDone = true;
                func(result, '[DONE]'); // **实时传递数据**
                break; // **提前结束流**
            }

            // **检查 textChunk 是否包含 [DONE]**
            if (textChunk.includes("[ERROR]")) {
                console.log("检测到 [ERROR]，结束流式读取");
                isDone = true;
                func(result, '[ERROR]'); // **实时传递数据**
                break; // **提前结束流**
            }

            result += textChunk;
            func(result, textChunk); // **实时传递数据**
        }

        // console.log("数据流结束");
        // return isDone ? "[DONE]" : result; // **返回最终结果**

    } catch (error) {
        // this.$message.error('哎呀，程序出错了');
        console.error("请求失败:", error);
    } finally {
        // console.error("finally!");
        clearTimeout(timeoutId); // 确保超时定时器被清除
    }
};

export const PostMsgStreamCopy = async (path, data, func, timeout = 60000) => {


    const controller = new AbortController();
    const signal = controller.signal;

    try {
        const response = await fetch(HTTP_MSG + path, {
            method: "POST",
            headers: {
                "Authorization": token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
            signal, // 绑定信号，支持中止
        });


        if (!response.body) throw new Error("响应体为空");

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        let result = '';
        let isDone = false; // **标记流是否已完成**

        while (true) {
            const {done, value} = await reader.read();

            if (done) break;

            const textChunk = decoder.decode(value, {stream: true});

            // console.log("收到数据块:", textChunk);

            // **检查 textChunk 是否包含 [DONE]**
            if (textChunk.includes("[DONE]")) {
                console.log("检测到 [DONE]，结束流式读取");
                isDone = true;
                func(result, '[DONE]'); // **实时传递数据**
                break; // **提前结束流**
            }

            // **检查 textChunk 是否包含 [DONE]**
            if (textChunk.includes("[ERROR]")) {
                console.log("检测到 [ERROR]，结束流式读取");
                isDone = true;
                func(result, '[ERROR]'); // **实时传递数据**
                break; // **提前结束流**
            }

            result += textChunk;
            func(result, textChunk); // **实时传递数据**
        }

        // console.log("数据流结束");
        // return isDone ? "[DONE]" : result; // **返回最终结果**

    } catch (error) {
        // this.$message.error('哎呀，程序出错了');
        console.error("请求失败:", error);
    } finally {

    }
};


// 时间转换
export const formatter = (cellValue) => {

    if (!cellValue) return '';  // 如果没有时间戳，返回空字符串
    const date = new Date(cellValue);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
